import { Grid } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { setActiveActionCard } from "components/app/App.slice";
import KebabMenu from "components/common/KebabMenu";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import { useContext } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { accessTypes, brandDeadLine, messageTypes } from "utils/CommonConstants";
import { getOwnersList, matchOwnerWithHltId, matchPlanType } from "utils/CommonFunctions";
import { planTypes } from "utils/Types";
import ActionCardDialogsContext from "./Context";
interface Props {
  planId: number | undefined;
  sectionId: number;
  cardId: number;
  item: any;
  isDisabled: boolean;
}

function Menu(props: Props) {
  const { planId, sectionId, cardId, item, isDisabled = false } = props;
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const dispatch = useAppDispatch();
  const { setIsOpenEditActionDialog, setIsOpenDeleteActionDialog, setIsOpenViewActionDialog } =
    useContext(ActionCardDialogsContext);
  const restrictPlanType = useAppSelector((state) => state.myPlanDetails.myPlanDetails.planType);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);

  const SectionMenu = [
    {
      label: "Edit Action",
      icon: EditIcon,
      accessType: accessTypes.update,
      enabled: true,
      action: (e: any) => {
        if (matchPlanType(restrictPlanType) && item?.cardEditable === "N") {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "action",
              setState: setFeedbackDetails({ shouldShow: false }),
              messageType: restrictPlanType === brandDeadLine ? messageTypes.deadlinePlan : messageTypes.initiativePlan,
              actionType: "edit"
            })
          );
          return;
        }
        dispatch(setActiveActionCard({ planId, planType: planTypes.MyPlans, sectionId, cardId, ...item }));
        setIsOpenViewActionDialog(false);
        setIsOpenEditActionDialog(true);
      }
    },
    {
      label: "Delete Action",
      icon: DeleteIcon,
      accessType: accessTypes.delete,
      enabled: true,
      action: () => {
        if (!isCorp && !matchOwnerWithHltId(selectedMyPlanDetail?.owners)) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "action",
              displayName: getOwnersList(),
              setState: setFeedbackDetails({ shouldShow: false }),

              messageType:
                selectedMyPlanDetail?.owners?.length > 1 ? messageTypes.multipleOwners : messageTypes.singleOwner
            })
          );
          return;
        } else if (matchPlanType(restrictPlanType) && item?.cardEditable === "N") {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "action",
              setState: setFeedbackDetails({ shouldShow: false }),

              messageType: restrictPlanType === brandDeadLine ? messageTypes.deadlinePlan : messageTypes.initiativePlan
            })
          );
          return;
        }
        dispatch(setActiveActionCard({ planId, planType: planTypes.MyPlans, sectionId, cardId, ...item }));
        setIsOpenDeleteActionDialog(true);
      }
    }
  ];

  return (
    <>
      <Grid item xs={6} display="flex" justifyContent="flex-end" onClick={(e) => !isDisabled && e.stopPropagation()}>
        <KebabMenu options={SectionMenu} isDisabled={isDisabled} sx={{ cursor: !isDisabled ? "pointer" : "auto" }} />
      </Grid>
    </>
  );
}

export default Menu;
